import React from 'react';


const OurStory = () => {
  return (

    <div className="our-story">
        <h1>our story</h1>
        <h1>NoluLove's Fragrance</h1>
      <h2>A scent as unforgettable as you.</h2>
      
      <div className="image-container">
  <img src="/images/strawberry perfume.jpg" alt="Our Story" />
  <img src="/images/pink flur.jpg" alt="Our Story" />
  <img src="/images/rose perfume.jpg" alt="Our Story" />
</div>
      <p>There’s something magical about a fragrance—it’s more than just a scent; it’s a memory, a feeling, a confidence boost in a bottle.</p>
      <p>At NoluLove’s Fragrance, we believe every girl deserves to feel beautiful, powerful, and unforgettable. Our journey began with a simple dream: to create perfumes that celebrate femininity in all its forms. Whether you're soft and romantic, bold and daring, or elegantly mysterious, there’s a scent for every side of you.</p>
      <p>Inspired by roses at sunrise, strawberries kissed by the sun, and the soft petals of pink flowers, our fragrances are carefully crafted to capture the essence of luxury and self-love. Each bottle is designed not just to smell good but to make you feel like the best version of yourself—confident, radiant, and effortlessly beautiful.</p>
       <h2> Wear NoluLove’s Fragrance and step into your own fairytale. </h2>
    </div>
  );
};

export default OurStory;
